import type { FormatNumberOptions } from 'react-intl';

const simpleCurrencyFormat: FormatNumberOptions = {
  style: 'currency',
  currency: 'USD',
};

const currencyFormat: FormatNumberOptions = {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'narrowSymbol',
};

const noDigitsCurrencyFormat: FormatNumberOptions = {
  ...currencyFormat,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

const customCurrencyFormat = (currency: string, format: FormatNumberOptions): FormatNumberOptions => {
  return { ...format, currency };
};

const percentageFormat: FormatNumberOptions = {
  style: 'percent',
  maximumFractionDigits: 2,
};

const noDigitsPercentFormat: FormatNumberOptions = {
  style: 'percent',
  maximumFractionDigits: 0,
};

const cmFormat: FormatNumberOptions = { style: 'unit', unit: 'centimeter' };

export {
  currencyFormat,
  noDigitsCurrencyFormat,
  simpleCurrencyFormat,
  customCurrencyFormat,
  noDigitsPercentFormat,
  cmFormat,
  percentageFormat,
};
